import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { useModalStore } from 'state/useModalStore'
import { PaymentType, usePaymentStore } from 'state/usePaymentStore'
import { useTranslation } from 'translations'
import { formatCode } from 'utils'

const SelectPayment = ({ onClose, open, onDelete }) => {
	const { t } = useTranslation()

	const paymentList = usePaymentStore((s) => s.paymentList)
	const setSelectedPayment = usePaymentStore((s) => s.setSelectedPayment)
	const setModalPayment = useModalStore((s) => s.setModalPayment)

	const handleAdd = (item) => {
		setModalPayment({ open: true, modalData: { type: item ? "EDIT" : "CREATE", data: item } })
		onClose()
	}

	const handleSelect = (item: PaymentType) => {
		setSelectedPayment(item)
		onClose()
	}

	return (
		<Drawer
			title={<p className='text-center font-bold text-xl'>{t("Saved recipients")}</p>}
			placement="bottom"
			className='container !px-0'
			closable={false}
			onClose={onClose}
			height="70%"
			open={open}
			key="set-recipient"
		>
			<div className="flex flex-col gap-3">
				<Button type="primary" className='w-full' onClick={() => handleAdd(null)}>
					{t("Add new")}
				</Button>

				{
					!paymentList
						? <></>
						: paymentList.map(item => (
							<div className="border-solid border-[1px] rounded-lg border-[#ccc] flex items-center gap-2 p-3" key={item.id}>
								<div className="flex items-center justify-between gap-4 w-full">
									<div className="flex flex-col gap-1 flex-1" onClick={() => handleSelect(item)}>
										<p className="font-bold uppercase">{item.account_holder}</p>
										<p className="font-medium text-secondary uppercase flex-1">
											{item.name}
										</p>
										<p className="font-medium text-secondary uppercase flex-1">
											{formatCode(item.account_number, 3, 4, "***")}
										</p>
									</div>

									<div className="flex items-center justify-end gap-4">
										<EditOutlined className='text-lg' onClick={() => handleAdd(item)} />
										<DeleteOutlined className='text-lg' onClick={() => {
											onDelete(item.id)
											onClose()
										}} />
									</div>
								</div>
							</div>
						))
				}
			</div>
		</Drawer>
	)
}

export default SelectPayment